export default "__VITE_ASSET__BBVIERP3__"